import { useLocalSearchParams } from 'expo-router';
import { useSetAtom } from 'jotai';
import { useEffect } from 'react';

import { billReviewSourceAtom } from '../../../bills/state/BillsAtoms';
import SpinwheelBillsReview from '../../../onboarding/components/billReview/SpinwheelBillsReview';

export default function SpinwheelBillsReviewTestScreen() {
    const { source } = useLocalSearchParams<{ source?: string }>();
    const setBillReviewSource = useSetAtom(billReviewSourceAtom);

    useEffect(() => {
        if (source === 'before-money-map-session') {
            // Set a custom source so handleGoBack knows to go to /home
            setBillReviewSource('home-review');
        } else if (source === 'home') {
            // Coming from home - back button should go to /home
            setBillReviewSource('home');
        }
    }, [source, setBillReviewSource]);

    return <SpinwheelBillsReview />;
}
